import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppMainComponent } from './modules/common/component';
import { AppNotfoundComponent } from './pages/notfound/app.notfound.component';
import { AppErrorComponent } from './pages/error/app.error.component';
import { AppAccessdeniedComponent } from './pages/access/app.accessdenied.component';
import { AppLoginComponent } from './pages/auth/login/app.login.component';
import { NoAuthGuard } from './modules/common/guards';
import { AppUnconfirmedComponent } from './pages/unconfirmed/app.unconfirmed.component';
import { ServerDownComponent } from './pages/server-down/server-down.component';
import { MsalGuard } from '@azure/msal-angular';
import { RedirectComponent } from './pages/redirect/redirect.component';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', redirectTo: 'login', pathMatch: 'full'
            },
            {
                path: 'user',
                component: AppMainComponent,
                canActivate:[MsalGuard],
                children: [
                    {
                        path: '',
                        redirectTo:'redirect',
                        pathMatch:'full'
                    },
                    {
                     path:'redirect',
                     component:RedirectComponent
                    },
                    {
                        path: 'dashboard',
                        loadChildren: () => import('src/app/modules/user/dashboard/dashboard.module').then(m => m.DashboardModule)
                    },
                    {
                        path:'record',
                        loadChildren: () => import('src/app/modules/user/record/record.module').then(m => m.RecordModule)
                    },
                     {
                        path:'other-requests',
                        loadChildren: () => import('src/app/modules/user/other-request/other-request.module').then(m => m.OtherRequestModule)
                    },
                    {
                      path:'introduction',
                      loadChildren:()=>  import('src/app/modules/user/introduction/introduction.module').then(m => m.IntroductionModule)
                    },
                    {
                        path: 'supplier',
                        loadChildren: () => import('src/app/modules/user/create-vendor/create-vendor.module').then(m => m.CreateVendorModule)
                    },
                    {
                        path: 'update-extend-unblock',
                        loadChildren: () => import('src/app/modules/user/update-form/update-extend-unblock.module').then(m => m.UpdateExtendUnblockModule)
                    },
                         {
                        path: 'modify-supplier',
                        loadChildren: () => import('src/app/modules/user/update-form/update-extend-unblock.module').then(m => m.UpdateExtendUnblockModule)
                    },
                    {
                        path: 'admin',
                        loadChildren: () => import('src/app/modules/user/administration/administration.module').then(m => m.AdministrationModule)
                    },
                    {
                        path: 'master-data',
                        loadChildren: () => import('src/app/modules/user/master-data/master-data.module').then(m => m.MasterDataModule)
                    },
                    {
                        path: 'profile',
                        loadChildren: () => import('src/app/modules/profile/profile.module').then(m => m.ProfileModule)
                    }

                ]
            },
            { path: 'error', component: AppErrorComponent },
            { path: 'access', component: AppAccessdeniedComponent},
            { path: 'notfound', component: AppNotfoundComponent },
            { path: 'unconfirmed', component: AppUnconfirmedComponent },
            { path: 'server-down', component: ServerDownComponent },
            { path: 'login', component: AppLoginComponent,canActivate:[NoAuthGuard]},
            { path: '**', redirectTo: '/notfound' },
        ], { scrollPositionRestoration: 'enabled' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
